/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import ClosedCaptions from './video-closed-captions';

export * from './closed-captions-props';
export * from './video-closed-captions';
export * from './video-closed-captions-settings';

/**
 * Exporting the ClosedCaptions components.
 */
export { ClosedCaptions };
